import { fixIndent } from "../utils/fix-indent";
import { Robot } from "./objects/Robot";
import { Goal } from "./objects/Goal";
export const defaultSpawners = {
    r: (map, pos) => [new Robot(undefined, map, pos)],
    g: (map, pos) => [new Goal(map, pos)],
};
export class LevelSpec {
    constructor(details) {
        this.details = details;
    }
    get title() {
        return this.details.title;
    }
    get goal() {
        return this.details.goal;
    }
    get helpText() {
        return this.details.helpText;
    }
    get width() {
        return this.details.layout[0].length;
    }
    get height() {
        return this.details.layout.length;
    }
    get lockedLines() {
        return this.details.lockedLines;
    }
    get maxLines() {
        return this.details.maxLines || false;
    }
    get defaultCode() {
        return fixIndent(this.details.defaultCode);
    }
    get isDeliveryGoal() {
        return this.details.isDeliveryGoal ? this.details.isDeliveryGoal : () => false;
    }
    testGoal(world) {
        if (this.maxLines) {
            if (world.getCodeLineCount() > this.maxLines) {
                return {
                    win: false,
                    reason: 'You have exceeded the maximum number of lines.',
                };
            }
        }
        return this.details.testGoal ? this.details.testGoal(world) : undefined;
    }
    getTile(x, y) {
        return this.details.layout[y][x];
    }
    hasFloor(x, y) {
        return this.getTile(x, y) !== ' ';
    }
    getSpawner(x, y) {
        const tile = this.getTile(x, y);
        if (this.details.spawners && this.details.spawners[tile]) {
            return this.details.spawners[tile];
        }
        if (defaultSpawners[tile]) {
            return defaultSpawners[tile];
        }
        return () => [];
    }
}
